import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Users from "./files/users";
import UserDetails from "./files/userDetails";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    });

    return (
        <div style={{ height: "100%" }}>
            {isLoaded && (
                <div style={{ height: "100%" }}>
                    <Routes>
                        <Route path="/" element={<Users />} />
                        <Route path="/userDetails/:id" element={<UserDetails />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
